const routes = [
    {
        path: '/',
        redirect: '/index',
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import('@/views/ai/Index'),
                meta: { title: '智能检察官', auth: true}
            }
        ]
    },
    {
        path: '/ai',
        name: 'ai',
        component: () => import('@/views/ai/Index'),
        meta: { title: '智能检察官', auth: false}
    },
    {
        path: '/question',
        name: 'question',
        component: () => import('@/views/question/Index'),
        meta: { title: '问答', auth: false}
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/error/NotFound'),
        meta: { title: '404' }
    },
    {
        path: '*',
        redirect: { name: '404' }
    }
];
export default routes
